import { InjectionToken } from "@angular/core";
import { IInfoModalService } from "./i-info-modal.service";

export const infoModalServiceInjectionToken: InjectionToken<IInfoModalService> =
  new InjectionToken<IInfoModalService>("digital-signage.user-dashboard.dashboard-web.InfoModalService");
